// extracted by mini-css-extract-plugin
export default {"yes":"checkout_yes__L4fVT"};